import { FormInput } from '@common/components/forms';
import { DisplayGroup } from '@common/components/forms/fields';
import { SuspenseButton } from '@common/components/utility';
import { useApp } from '@common/hooks';
import { HospitalModel, OrganizationListingModel } from '@common/models';
import { FeatureFlags } from '@common/models/Enums';
import { SmsModel } from '@common/models/SmsModel';
import { ServiceHelper } from '@common/services';
import { SmsService } from '@common/services/smsService';
import { observer } from "mobx-react";
import React, { useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';

interface IProps {
    hospital: HospitalModel;
    pricingTierOrganization: OrganizationListingModel | undefined;
}

export const LocationDetailsDisplay = observer((props: IProps) => {
    const { configuration } = useApp();
    const [showConfirmSms, setShowConfirmSms] = useState<boolean>(false);
    const { reset, handleSubmit, control } = useForm<SmsModel>();

    const onCloseModal = () => {
        reset();
        setShowConfirmSms(false);
    }

    const onSubmit = (data: SmsModel) => {
        data.fromNumber = props.hospital.outboundSMSPhone;

        SmsService.validateSms(data)
            .then(() => ServiceHelper.showSuccess("Succeded to validate SMS Phone Number.", { showSuccess: true, showError: true }))
            .catch(() => ServiceHelper.showError("Failed to validate SMS Phone Number."))
            .then(() => onCloseModal());
    }

    return (
        <>
            <Row className="pt-4">
                <Col md={4}>
                    <DisplayGroup type="tel" controlid={"phone"} text={"Phone"} value={props.hospital.phone} />
                </Col>
                <Col md={4}>
                    <DisplayGroup type="tel" controlid={"sms"} text={"SMS"} value={props.hospital.outboundSMSPhone} />
                    {
                        configuration.hasFeatureFlag(FeatureFlags.InAppSms) && props.hospital.outboundSMSPhone !== ''
                            ? <Button variant='primary' onClick={() => setShowConfirmSms(true)}>Validate SMS</Button>
                            : null
                    }
                </Col>
                <Col md={4}>
                    <DisplayGroup type="tel" controlid={"fax"} text={"Fax"} value={props.hospital.fax} />
                </Col>
            </Row>
            <Row className="pt-4">
                <Col md={4}>
                    <DisplayGroup controlid={"email"} text={"Email"} value={props.hospital.email} />
                </Col>
                <Col md={4}>
                    <DisplayGroup controlid={"url"} text={"URL"} value={props.hospital.url} />
                </Col>
                <Col md={4}>
                    <DisplayGroup controlid={"pricingTier"} text="Pricing Tier" value={props.pricingTierOrganization ? props.pricingTierOrganization.name : undefined} />
                </Col>
            </Row>

            {
                showConfirmSms
                    ? <Modal size="lg" centered show={showConfirmSms} onHide={onCloseModal} backdrop="static">
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <Modal.Header closeButton>
                                <Modal.Title>SMS Validation</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row>
                                    <Col md={12}>
                                        <FormInput
                                            className="mb-2"
                                            type="tel"
                                            fieldName={`toNumber`}
                                            control={control}
                                            label="To Number"
                                            highlightDirty={true}
                                            isRequired={true}
                                        />
                                    </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <SuspenseButton type='submit' hideSpinner={false} tag={SmsService.tags.validatePhoneNumber} variant='primary'>Validate</SuspenseButton>
                                <Button variant='outline-primary' onClick={onCloseModal}>Cancel</Button>
                            </Modal.Footer>
                        </Form>
                    </Modal >
                    : null
            }
        </>
    )
});
